<template>
  <el-container direction="vertical">
    <c-header/>
    <c-main/>
    <c-footer/>
  </el-container>
</template>

<script>
import CHeader from "@/layout/components/CHeader.vue";
import CMain from "./components/CMain.vue";
import CFooter from "./components/CFooter.vue";

export default {
  components: {
    CHeader,
    CMain,
    CFooter
  },
  name: "Layout"
}
</script>
